// extracted by mini-css-extract-plugin
export default {"succes_container":"PaymentSuccess_succes_container__0c3Nu","text":"PaymentSuccess_text__jEesH","btn_home":"PaymentSuccess_btn_home__b92IN"};